<template>
    <contract-paper
        v-if="isRender"
        :loader="!isFetchedFileTypes"
        :isFilled="isFilled"
        :contractLink="main"
        :contractFiles="contract"
        :ogrnFiles="ogrn"
        :onUpload="upload"
        @remove="handleRemove"
    />
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import {
    uploadContractFile,
    uploadOgrnFile,
} from '../../../services/api/file';
import ContractPaper from './ContractPaper';

const uploader = {
    contract: uploadContractFile,
    ogrn: uploadOgrnFile,
};

export default {
    name: 'contract-paper-container',
    components: {
        ContractPaper,
    },
    data() {
        return {
            contract: [],
            ogrn: [],
        }
    },
    methods: {
        ...mapActions('fileUploader', ['uploadProfileContract', 'uploadProfileOgrn']),

        upload(field, files) {
            switch (field) {
                case 'contract':
                    return this.uploadProfileContract(files)
                        .then((res) => {
                            this[field] = this[field].concat(res.data);

                            return res;
                        });
                case 'ogrn':
                    return this.uploadProfileOgrn(files)
                        .then((res) => {
                            this[field] = this[field].concat(res.data);

                            return res;
                        });
                default:
                    throw new Error(field + ' - invalid field');
            }
        },
        handleRemove({ field, file, index }) {
            const newFiles = this[field].concat([]);
            newFiles.splice(index, 1);

            this[field] = newFiles;
        }
    },
    computed: {
        ...mapState('contract', ['main']),
        ...mapState('profile', ['profile', 'isFetched', 'contractStatusIsSigned']),
        ...mapGetters('profile', ['isFilled']),
        ...mapGetters('fileUploader', {
            isFetchedFileTypes: 'isFetched'
        }),
        isRender() {
            return this.isFetched && !this.contractStatusIsSigned;
        }
    }
}
</script>


// WEBPACK FOOTER //
// ContractPaperContainer.vue?6e227d4c